import getters from './getters'
import mutations from './mutations'
import actions from './actions'

export const initialState = {
    message: '',
    isError: false,
    warning: '',
}

export default {
    namespaced: true,
    state: { ...initialState },
    getters,
    mutations,
    actions,
}
